module.exports = __webpack_public_path__ + "src/assets/img/heavy-rain.81212836.svg";